<template>
  <div class="manufacture">
    <div class="container">
      <div class="row">
        <div class="p-5 img-100 text-center">
          <img class="img-100" src="@/assets/img/manufacture/img18.png" alt />
          <div
            class="con text-left"
          >未来移动医疗一直坚信品质是品牌的根本，品质是客户安全的保障，公司从研发、生产到服务等相关人员，均以高度的责任感和使命感，充分洞察细节问题，对每一个步骤都建立了严格的质量标准，并坚持执行，终以卓越的品质管理体系赢得了多国国际权威认证机构的认可：</div>
        </div>
      </div>
    </div>

    <div class="container-fluid time">
      <div class="row">
        <img class="img" src="@/assets/img/manufacture/time.png" alt />
      </div>
    </div>

    <div class="p-t">
      <div class="container">
        <div class="row">
          <div class="col-md-6 patent">
            <div class="title">专利认证</div>
            <div class="introductory">未来移动医疗坚持研发，至今已获得数十项专利，一直引领行业内的发展，探索行业更多可能性。</div>
          </div>

          <div class="col-md-6">
            <el-carousel indicator-position="none" :height="height">
              <el-carousel-item
                class="swiper-img text-center"
                v-for="item in zhuanliList"
                :key="item"
              >
                <img class="img shadow-sm" :src="item" alt srcset />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="p-t">
      <div class="container">
        <div class="row">
          <div class="col-md-6 patent">
            <div class="title">质量认证</div>
            <div
              class="introductory"
            >公司的质量体系及NEB-001雾化器产品通过了美国FDA认证、欧盟CE认证、中国NMPA认证、韩国KGMP认证，获得了参与国际竞争的通行证。</div>
          </div>

          <div class="col-md-6">
            <el-carousel indicator-position="none" :height="height">
              <el-carousel-item
                class="swiper-img text-center"
                v-for="item in zhiliangList"
                :key="item"
              >
                <img class="img shadow-sm" :src="item" alt srcset />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: "",
      zhuanliList: [
        require("../../assets/img/manufacture/zhuanli/img (1).png"),
        require("../../assets/img/manufacture/zhuanli/img (2).png"),
        require("../../assets/img/manufacture/zhuanli/img (3).png"),
        require("../../assets/img/manufacture/zhuanli/img (4).png"),
        require("../../assets/img/manufacture/zhuanli/img (5).png"),
        require("../../assets/img/manufacture/zhuanli/img (6).png"),
        require("../../assets/img/manufacture/zhuanli/img (7).png"),
        require("../../assets/img/manufacture/zhuanli/img (8).png"),
        require("../../assets/img/manufacture/zhuanli/img (9).png"),
        require("../../assets/img/manufacture/zhuanli/img (10).png"),
        require("../../assets/img/manufacture/zhuanli/img (11).png"),
        require("../../assets/img/manufacture/zhuanli/img (12).png")
      ],
      zhiliangList: [
        require("../../assets/img/manufacture/zhiliang/img (1).png"),
        require("../../assets/img/manufacture/zhiliang/img (2).png"),
        require("../../assets/img/manufacture/zhiliang/img (3).png"),
        require("../../assets/img/manufacture/zhiliang/img (4).png")
      ]
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    if (w > 576) {
      that.height = 500 + "px";
    } else {
      that.height = 400 + "px";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;

      if (w > 576) {
        that.height = 500 + "px";
      } else {
        that.height = 400 + "px";
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.con {
  margin-top: 20px;
}
.time {
  background: #f5f5f5;

  .img {
    width: 60%;
    margin-left: 20%;
    padding: 60px 0;
  }
}

.patent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .title {
    color: #504747;
    font-size: 28px;
  }

  .introductory {
    font-size: 16px;
    color: #6c6c6c;
    margin-top: 10px;
  }
}
.p-t {
  padding: 60px;
}

.swiper-img {
  display: flex;
  align-items: center;
  justify-content: center;
  .img {
    width: 50%;
  }
}

@media (max-width: 576px) {
  .time {
    .img {
      width: 80%;
      margin-left: 10%;
      padding: 30px 0;
    }
  }
  .p-t {
    padding: 30px;
  }
}
</style>